exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".link-img[data-v-eebb03c2]{border-radius:100%;height:48px;width:48px}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/pages/Links.vue"],"names":[],"mappings":"AACA,2BACE,mBAAoB,AACpB,YAAa,AACb,UAAY,CACb","file":"Links.vue","sourcesContent":["\n.link-img[data-v-eebb03c2] {\n  border-radius: 100%;\n  height: 48px;\n  width: 48px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-eebb03c2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Links.vue
// module id = 977
// module chunks = 18